<div class="header">
  <div>
    <h2>{{ "pages.admin.audit.title" | translate }}</h2>
    <p class="subtitle">{{ "pages.admin.audit.subtitle" | translate }}</p>
  </div>

  <div class="filters">
    <app-search-input
      [value]="search"
      (valueChange)="onSearch($event)"
      placeholderKey="pages.admin.audit.filter.search"
    ></app-search-input>

    <nb-select
      size="small"
      placeholder="{{ 'pages.admin.audit.filter.scope' | translate }}"
      [selected]="scope"
      (selectedChange)="onScope($event)"
    >
      <nb-option [value]="null">{{
        "pages.admin.audit.filter.allScopes" | translate
      }}</nb-option>
      <nb-option *ngFor="let s of scopes" [value]="s">{{
        "pages.admin.audit.scopes." + s | translate
      }}</nb-option>
    </nb-select>

    <nb-select
      size="small"
      placeholder="{{ 'pages.admin.audit.filter.action' | translate }}"
      [selected]="action"
      (selectedChange)="onAction($event)"
    >
      <nb-option [value]="null">{{
        "pages.admin.audit.filter.allActions" | translate
      }}</nb-option>
      <nb-option *ngFor="let a of actions" [value]="a">{{
        "pages.admin.audit.actions." + a | translate
      }}</nb-option>
    </nb-select>

    <nb-select size="small" [selected]="days" (selectedChange)="onDays($event)">
      <nb-option *ngFor="let d of dayOptions" [value]="d">{{
        "pages.admin.audit.filter.days" | translate : { days: d }
      }}</nb-option>
    </nb-select>
  </div>
</div>

<nb-card>
  <nb-card-body>
    <app-table
      rowIdKey="id"
      [title]="'pages.admin.audit.title' | translate"
      [columns]="columns"
      [data]="data"
      [globalActions]="globalActions"
      [selectable]="false"
      [showPagination]="false"
      [maxVisibleItems]="pageSize"
    ></app-table>

    <!-- Paged on the server inside a frozen window: the log grows at the head
         while it is read, so plain offsets would repeat or skip rows. -->
    <div class="pager" *ngIf="total">
      <span class="range">
        {{
          "pages.admin.audit.range"
            | translate : { from: rangeStart, to: rangeEnd, total: total }
        }}
      </span>

      <div class="pager__controls">
        <button
          nbButton
          ghost
          size="small"
          [disabled]="page === 0 || loading"
          (click)="goToPage(page - 1)"
          [attr.aria-label]="'pages.admin.audit.previousPage' | translate"
        >
          <nb-icon icon="chevron-left-outline"></nb-icon>
        </button>
        <span class="page-of">
          {{
            "pages.admin.audit.pageOf"
              | translate : { page: page + 1, pages: pageCount }
          }}
        </span>
        <button
          nbButton
          ghost
          size="small"
          [disabled]="page + 1 >= pageCount || loading"
          (click)="goToPage(page + 1)"
          [attr.aria-label]="'pages.admin.audit.nextPage' | translate"
        >
          <nb-icon icon="chevron-right-outline"></nb-icon>
        </button>

        <nb-select size="small" [selected]="pageSize" (selectedChange)="onPageSize($event)">
          <nb-option *ngFor="let size of pageSizes" [value]="size">{{ size }}</nb-option>
        </nb-select>
      </div>
    </div>

    <p class="page-hint">{{ "pages.admin.audit.hint" | translate }}</p>
  </nb-card-body>
</nb-card>
